import { ReactNode } from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useBarChartScrollContainer, BarChartScrollLayout } from './useBarChartScrollContainer';

export type BarChartScrollContainerProps = {
    labelCount: number;
    scrollLayout: BarChartScrollLayout;
    children: (props: { innerWidthPx: number }) => ReactNode;
};

/**
 * 棒グラフ用のスクロールコンテナ
 * - expandモード: 最小幅を確保し、コンテナ幅を超える場合は横スクロール可能にする
 * - fitモード: コンテナ幅に合わせ、横スクロールなし
 */
export function BarChartScrollContainer({
    labelCount,
    scrollLayout,
    children,
}: BarChartScrollContainerProps) {
    const { t } = useTranslation('analysis');
    const { scrollRef, innerWidthPx, containerWidth, minRequiredWidthPx } =
        useBarChartScrollContainer(labelCount, { layout: scrollLayout });

    return (
        <div className="w-full h-full flex flex-col">
            <div
                ref={scrollRef}
                className={clsx(
                    'relative flex-1 min-h-0 overflow-y-hidden',
                    scrollLayout === 'expand' ? 'overflow-x-auto' : 'overflow-x-hidden',
                )}
            >
                <div
                    className="inline-block h-full align-top"
                    style={{ width: innerWidthPx, minWidth: minRequiredWidthPx || undefined }}
                >
                    {children({ innerWidthPx })}
                </div>
            </div>
            {minRequiredWidthPx > containerWidth && containerWidth > 0 ? (
                <p className="mt-1 px-2 text-center text-xs text-gray-400">
                    {t('chart.scrollRight', { defaultValue: '右にスクロールできます →' })}
                </p>
            ) : null}
        </div>
    );
}
